// Resolves the ISO code (GBP, USD, ...) for a currency id.
//
// The invoice and quotation lists have no currency filter and the stored user
// only carries the symbol, so the code that the export file names start with
// has to come from the currency list. That list is static, so it is fetched
// once per page load and reused.

import axios from "axios";
import { CURRENCY_LIST } from "../config/url";

let pendingRequest = null;
let currencies = null;

export async function loadCurrencies() {
  if (currencies) return currencies;
  if (!pendingRequest) {
    pendingRequest = axios
      .get(CURRENCY_LIST)
      .then((res) => {
        currencies = Array.isArray(res.data?.response) ? res.data.response : [];
        return currencies;
      })
      .catch(() => [])
      .finally(() => {
        pendingRequest = null;
      });
  }
  return pendingRequest;
}

// Returns the ISO code for `currencyId`, or ALL when it cannot be resolved -
// a missing code must not stop the download.
export async function resolveCurrencyCode(currencyId) {
  if (!currencyId) return "ALL";
  const list = await loadCurrencies();
  const match = list.find((item) => String(item.id) === String(currencyId));
  return match?.code || "ALL";
}
